exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".body{margin:0 10%}.center{text-align:center}.tcTitle{font-weight:400}.sdgTitle{font-size:45px}.underLine{text-decoration:underline}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/TermsOfUse/TermsOfUse.vue"],"names":[],"mappings":"AACA,MACI,YAAc,CACjB,AACD,QACI,iBAAmB,CACtB,AACD,SACI,eAAmB,CACtB,AACD,UACI,cAAgB,CACnB,AACD,WACI,yBAA2B,CAC9B","file":"TermsOfUse.vue","sourcesContent":["\n.body {\n    margin: 0 10%;\n}\n.center {\n    text-align: center;\n}\n.tcTitle{\n    font-weight:normal;\n}\n.sdgTitle{\n    font-size: 45px;\n}\n.underLine{\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b15d17e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TermsOfUse/TermsOfUse.vue
// module id = 502
// module chunks = 15